<div
  class="jb-accordion grid-offset-l jb-grid one-up"
  *ngIf="!!accordionBlock && !!accordionBlock.length"
>
  <jb-accordion>
    <ng-container
      *ngFor="let panel of accordionBlock; index as i"
    >
      <jb-expansion-panel
        [isPrimary]="false"
        (opened)="onOpen(i)"
        (closed)="onClose(i)"
      >
        <jb-expansion-panel-header [isPrimary]="false">
          {{ !!panel?.data?.title ? panel?.data?.title : panel?.title }}
        </jb-expansion-panel-header>
        <jb-expansion-panel-row [isPrimary]="false" *ngIf="expandedItem === i">
          <ng-container *ngIf="panel?.data?.bodyText || panel?.bodyText">
            <jb-body-text-container
              [content]="
                !!panel?.data?.bodyText
                  ? panel?.data?.bodyText
                  : panel?.bodyText
              "
              [insideAccordion]="true"
            ></jb-body-text-container>
          </ng-container>
          <ng-container
            *ngIf="panel?.data?.bodyTextWithImage || panel?.bodyTextWithImage"
          >
            <jb-text-image-container
              [content]="
                !!panel?.data?.bodyTextWithImage
                  ? panel?.data?.bodyTextWithImage
                  : panel?.bodyTextWithImage
              "
              [insideAccordion]="true"
            ></jb-text-image-container>
          </ng-container>
        </jb-expansion-panel-row>
      </jb-expansion-panel>
    </ng-container>
  </jb-accordion>
</div>
